import { render, staticRenderFns } from "./CustomerTab.vue?vue&type=template&id=1e7f55e6&scoped=true&"
import script from "./CustomerTab.vue?vue&type=script&lang=js&"
export * from "./CustomerTab.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTab.vue?vue&type=style&index=0&id=1e7f55e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7f55e6",
  null
  
)

export default component.exports